module.exports = __webpack_public_path__ + "img/Powered_by_Peach_Payments.11863164.png";